import React from 'react';
import { FileText, ArrowLeft } from 'lucide-react';
import { useTheme } from '../../core/ui/ThemeContext';
import { useLanguage } from '../../core/i18n/LanguageContext';

const BanfHeader = ({ user, onBack }) => {
  const { isDarkMode } = useTheme();
  const { t } = useLanguage();

  return (
    <div className="relative">
      {/* Liquid Glass Header Background */}
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gray-900/20 border-b border-white/10 backdrop-blur-2xl shadow-[0_8px_32px_rgba(0,0,0,0.3)]'
        : 'bg-white border-b border-slate-200'
      }`}></div>
      <div className={`absolute inset-0 ${isDarkMode
        ? 'bg-gradient-to-r from-purple-900/5 via-transparent to-blue-900/5'
        : ''
      }`}></div>
      
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            {/* Liquid Glass FileText Icon */}
            <div className="relative group/icon">
              <div className={`absolute inset-0 rounded-xl blur-sm ${isDarkMode ? 'bg-gradient-to-br from-white/20 via-white/10 to-transparent' : 'hidden'}`}></div>
              <div className={`relative w-10 h-10 rounded-xl flex items-center justify-center ${isDarkMode
                ? 'bg-gradient-to-br from-purple-600/60 via-purple-700/50 to-purple-800/60 backdrop-blur-xl shadow-[0_6px_24px_rgba(147,51,234,0.25),inset_0_1px_0_rgba(255,255,255,0.3)] border border-white/20'
                : 'bg-brand/10 border border-brand/20'
              }`}>
                <FileText className={`w-5 h-5 ${isDarkMode ? 'text-white/90 drop-shadow-lg' : 'text-brand'}`} />
                <div className={`absolute top-0.5 left-0.5 w-2.5 h-2.5 bg-white/30 rounded-full blur-sm ${isDarkMode ? '' : 'hidden'}`}></div>
              </div>
            </div>
            <div>
              <h1 className={`text-2xl font-semibold ${isDarkMode
                ? 'bg-gradient-to-r from-white via-purple-200 to-white bg-clip-text text-transparent drop-shadow-lg'
                : 'text-slate-900'
              }`}>{t('banf.title')}</h1>
            </div>
          </div>
          
          {/* Liquid Glass Back Button */}
          <button
            onClick={onBack}
            className={`relative group/back overflow-hidden rounded-2xl transition-all duration-300 transform hover:scale-[1.01] active:scale-[0.99] ${
              isDarkMode ? '' : 'bg-slate-100 hover:bg-slate-200 border border-slate-200'
            }`}
            style={isDarkMode ? {
              background: 'linear-gradient(135deg, rgba(71,85,105,0.6) 0%, rgba(75,85,99,0.6) 50%, rgba(71,85,105,0.6) 100%)',
              backdropFilter: 'blur(20px)',
              border: '1px solid rgba(255,255,255,0.3)',
              boxShadow: '0 8px 32px rgba(0,0,0,0.4), inset 0 1px 0 rgba(255,255,255,0.2)'
            } : {}}
          >
            {/* Smooth Hover Overlay */}
            <div
              className={`absolute inset-0 rounded-2xl transition-all duration-300 opacity-0 group-hover/back:opacity-100 ${isDarkMode ? '' : 'hidden'}`}
              style={isDarkMode ? {
                background: 'linear-gradient(135deg, rgba(255,255,255,0.05) 0%, rgba(255,255,255,0.1) 50%, rgba(255,255,255,0.05) 100%)'
              } : {}}
            ></div>

            <div className={`relative z-10 px-4 py-2 flex items-center font-medium transition-all duration-300 ${
              isDarkMode ? 'text-white drop-shadow-lg group-hover/back:drop-shadow-xl' : 'text-slate-700'
            }`}>
              <ArrowLeft className="w-4 h-4 mr-2 transition-transform duration-300 group-hover/back:scale-110" />
              {t('banf.back')}
            </div>

            {/* Smooth Wave Effect */}
            <div className={`absolute inset-0 opacity-0 group-hover/back:opacity-100 transition-opacity duration-500 ${isDarkMode ? '' : 'hidden'}`}>
              <div
                className="absolute inset-0 transform -skew-x-12 -translate-x-full group-hover/back:translate-x-full transition-transform duration-800"
                style={{
                  background: 'linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.1) 50%, transparent 100%)'
                }}
              ></div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
};

export default BanfHeader;